import './App.css';
import Navbar from './components/navbar';
import Header from "./components/header.jsx";
import About from "./components/about.jsx";
import Portfolio from "./components/portfolio.jsx";
import Footer from "./components/footer.jsx";
import Contact from "./components/contact.jsx";

function App() {
  return (
    <>
      <Navbar/>
      <Header/>
      <About/>
      <Portfolio/>
      <Contact/>
      <Footer/>
    </>
  );
}

export default App;
